import FirebaseUsage from "../firebase.usage";
import {COLLECTIONS} from "../constants";
import {DocumentSnapshot, QuerySnapshot} from "firebase/firestore";
import store from "../../store/store";
import {WorkPackage} from "../../models/responses/work-package.model";
import TaskModel from "../../models/responses/task.model";
import {CpmTaskModel} from "../../models/responses/cpm-task.model";
import {convertIndexToSeconds} from "../../utils/cpm-functions/cpm-app/functions/handleEvent";
import moment from "moment/moment";
import TaskStatusModel from "../../models/responses/task-status.model";

const generateDetailedWorkPackage = (wp: WorkPackage, cpmMap, allTasks, taskCodeMap, calendarMap) => {
    const tasks: TaskModel[] = wp.assignedTaskCodes
        .map(taskCode => allTasks.get(taskCodeMap.get(taskCode)!))
        .filter((task): task is TaskModel => task !== undefined)
    let packageStart: null | number = null;
    let packageEnd: null | number = null;
    let isCritical = false;
    let isCriticalNow = false;
    let isNearCritical = false;
    let isInProgress = false;
    let drivingTaskStart: null | TaskModel = null;
    let drivingTaskEnd: null | TaskModel = null;
    tasks.forEach(task => {
        const cpmTask: CpmTaskModel = cpmMap.get(task.task_id);
        if (!cpmTask) return;
        const taskStart = convertIndexToSeconds(cpmTask.fs ? cpmTask.fs : cpmTask.es, cpmTask.cal_id, calendarMap);
        const taskEnd = convertIndexToSeconds(cpmTask.ff ? cpmTask.ff : cpmTask.ef, cpmTask.cal_id, calendarMap);
        const workingHours = calendarMap.get(`whd:${cpmTask.cal_id}`);
        if (packageStart === null || taskStart < packageStart) {
            packageStart = taskStart;
            drivingTaskStart = task;
        }
        if (packageEnd === null || taskEnd > packageEnd) {
            packageEnd = taskEnd;
            drivingTaskEnd = task;
        }
        if (cpmTask.float === 0 || (cpmTask.float && cpmTask.float < workingHours)) {
            isCritical = true;
            if (convertIndexToSeconds(cpmTask.ls, cpmTask.cal_id, calendarMap) <=
                (moment(new Date()).add(1, 'days').toDate().getTime() / 1000)) {
                isCriticalNow = true;
            }
        } else if (cpmTask.float && cpmTask.float < workingHours * 2) {
            isNearCritical = true;
        }
        if (task.status !== TaskStatusModel.NOT_STARTED && task.status !== TaskStatusModel.BLOCK) {
            isInProgress = true;
        }
    });

    return  {
        ...wp,
        packageStart,
        packageEnd,
        isCritical,
        isCriticalNow,
        isNearCritical,
        drivingTaskStart,
        drivingTaskEnd,
        isInProgress
    };
}

export class WorkPackageSubscription {
    static workPackages(contractId: string, projectId: string, callback: Function) {
        const completedChecklistMap = store.getState().task.completedChecklistMap;
        const workPackageMap = store.getState().workPackages.workPackageMap;
        return FirebaseUsage.queryListener(COLLECTIONS.WORK_PACKAGES, [
            ['contractId', '==', contractId],
            ['projectId', '==', projectId]
            ],
                (data: QuerySnapshot) => {
                let workPackages: WorkPackage[] = [];
                data.docs.forEach((doc: DocumentSnapshot) => {
                    const wpData = doc.data() as WorkPackage;
                    if (wpData.completedChecklist) {
                        wpData.completedChecklist.forEach(checklist => {
                             completedChecklistMap.set(`${wpData.workPackageId}:${checklist.id}`, checklist);
                        })
                    }
                    workPackages.push(wpData);
                    workPackageMap.set(wpData.workPackageId, wpData);
                });
                return callback(workPackages);
            });
    }

    static async workStreams(contractId: string, projectId: string, callback: Function) {
        return FirebaseUsage.getCompoundQuery(COLLECTIONS.WORK_STREAMS, [
                ['contractId', '==', contractId],
                ['projectId', '==', projectId]
            ])
            .then((data: QuerySnapshot) =>
                callback(data.docs.map((doc: DocumentSnapshot) => doc.data())));
    }
}